import QRCodeInsertModal, { QR_CODE_INSERT_MODAL } from './modal';

export { QR_CODE_INSERT_MODAL };

export default QRCodeInsertModal;
